import { render } from "./EntraApplications.vue?vue&type=template&id=cbd11d12&scoped=true"
import script from "./EntraApplications.vue?vue&type=script&lang=js"
export * from "./EntraApplications.vue?vue&type=script&lang=js"

import "./EntraApplications.vue?vue&type=style&index=0&id=cbd11d12&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbd11d12"]])

export default __exports__